export default __webpack_public_path__ + "static/resume-9fd8697fce77902d3f3bcbf1cbed978b.pdf";